import IconLink from '~/components/IconLink';

export type Props = {};

export const LinkBlock = (props: any) => {
  const linkNode = props.node as any;

  let link;
  if (linkNode.fields.linkType === 'custom') {
    link = linkNode.fields.url;
  } else {
    if (linkNode.fields.doc) {
      switch (linkNode.fields.doc.relationTo) {
        case 'pages':
          link = `/${linkNode.fields.doc.value.slug}`;
          break;
        case 'posts':
          link = `/blog/${linkNode.fields.doc.value.slug}`;
          break;
        case 'projects':
          link = `/project/${linkNode.fields.doc.value.slug}`;
          break;
        case 'media':
          link = `/media/${linkNode.fields.doc.value.filename}`;
          break;
        default:
          throw new Error(
            `Link is not working. Unsupported relationTo: ${linkNode.fields.doc.relationTo}`,
          );
      }
    } else {
      return <span>No doc in link selected</span>;
    }
  }

  return (
    <IconLink
      id={linkNode.id}
      block={false}
      href={link}
      overrideNewTab={linkNode.fields.newTab}
    >
      {linkNode.children[0].text}
    </IconLink>
  );
};
